'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Main: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.content}>
					<Typography variant='h1' className={styles.title}>
                        Интеграции
					</Typography>
					<Typography variant='p1' color='description' className={styles.description}>
                    Объединяем разрозненные ИТ-системы в единый работающий механизм. Настраиваем бесшовный обмен данными между сайтом, 1С, CRM и банками для автоматизации процессов и исключения ручных ошибок.
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<div className={styles.imageContainer}>
					<Image
						src="/images/integrations/main_desktop.svg"
						alt="Комплексные решения"
						width={1110}
						height={330}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src="/images/integrations/main_tablet.svg"
						alt="Комплексные решения"
						width={680}
						height={283}
						className={styles.tabletImage}
						unoptimized
					/>
					<Image
						src="/images/integrations/main_mobile.svg"
						alt="Комплексные решения"
						width={328}
						height={184}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

Main.displayName = 'Main'

export default Main